import { CloseButton } from "../CloseButton";
import { Text } from "../Base";
import { View } from "../View";
import { makeStyles } from "@mui/styles";
import { memo } from "react";
import { setMultiRoutesPopupLocation } from "../../reducers/matrixProfile";
import { useDispatch } from "react-redux";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  text: {
    fontSize: "18px",
  },
});

export const PopUpHeader = memo(() => {
  const styles = useStyles();
  const dispatch = useDispatch();

  return (
    <View className={styles.container}>
      <Text className={styles.text}>Multi-Route</Text>
      <CloseButton
        onClose={() => {
          dispatch(setMultiRoutesPopupLocation(null));
        }}
        dark={false}
      />
    </View>
  );
});
